<template>
	<main>
		<crumbs :crumbs="crumbs"></crumbs>
		<div class="wrap">
			<div class="title">戴尔科技集团</div>
			<div class="line"></div>
			<div class="clear list">
				<div class="left item" :class="[index >= Math.floor(speaker.length/4) * 4 ? 'end' : '']" v-for="(item,index) in speaker" :key="index" v-if="item.sort >= 100">
					<div class="box2" >
						<div class="avatar" :style="{backgroundImage:'url('+util.autoImage(item.avatar)+')'}"></div>
						<div class="element username">{{item.username}}</div>
						<div class="element-more job" v-html="item.job"></div>
					</div>
				</div>
				<div class="loading" v-if="data_loading"><loading></loading></div>
			</div>
			<div class="title">特邀嘉宾</div>
			<div class="line"></div>
			<div class="clear list">
				<div class="left item" :class="[index >= Math.floor(speaker.length/4) * 4 ? 'end' : '']" v-for="(item,index) in speaker" :key="index" v-if="item.sort < 100">
					<div class="box2" >
						<div class="avatar" :style="{backgroundImage:'url('+util.autoImage(item.avatar)+')'}"></div>
						<div class="element username">{{item.username}}</div>
						<div class="element-more job" v-html="item.job"></div>
					</div>
				</div>
				<div class="loading" v-if="data_loading"><loading></loading></div>
			</div>
			<div class="tips"><i>* </i>以上演讲嘉宾排名不分先后</div>
		</div>
	</main>
</template>

<script>
import Crumbs from "../../components/pc/Crumbs";
import Loading from "../../components/pc/Loading";
export default {
	name: 'honored',
	data() {
		return {
			query:"",
			speaker:[],
			data_loading:true,
		}
	},
	components:{
		Crumbs,Loading
	},
	computed:{
		crumbs() {
			return {title:"嘉宾介绍",min_title:"Speaker"}
		},
	},
	methods: {
		getGuestList(){
			this.http.request({
				api:"guest/getGuestList",
				data:{},
				success:(res)=>{
					this.speaker = res.list;
					this.data_loading = false;
					this.$nextTick(()=>{
						this.util.showBottom(true);
					})
				}
			})
		},
	},
	mounted() {
		this.query = this.$route.query;
		this.getGuestList();
	}
}
</script>

<style lang="scss" type="text/scss" scoped>

.wrap{background: #f1f1f1;padding-top: 44px;text-align: center;
	.title{font-size: 28px;text-align: center}
	.line{width: 230px;height:2px;margin: 2px auto 0; background: url("~@/assets/image/45.png") no-repeat center center;background-size: contain;}
	.category{text-align: center;margin: 30px auto 0;width: 1200px;display: none;
		.center{display: inline-block;
			.item{ width:180px; height:48px;border: 1px solid #0176ce;line-height: 48px;margin-right: 21px;font-size: 18px;color:#565656;cursor: pointer;transition: all .3s ease;margin-bottom: 20px;}
			.item:nth-child(6n){margin-right:0px;}
			.item.active{background: #0176ce;color:#fff;transition: all .3s ease;}
		}
	}
	.list{width: 1200px;padding: 30px 0 30px;margin: 0 auto;overflow: hidden; display: flex; flex-wrap: wrap; justify-content: center;
		.item{
			.box1{width: 245px;height:90px;padding: 20px; float: left;margin-bottom: 20px;margin-right: 20px;text-align: left;position: relative;background: #fff;box-shadow: 0 0 10px 5px rgba(0,0,0,.1);
				.username{font-size: 18px;color:#555555;border-bottom: 1px solid #d5e3f2;padding-bottom: 10px;line-height: 20px;}
				.job{margin-top: 10px;font-size: 14px;line-height: 22px; color:#aaaaaa;white-space: pre-line;-webkit-line-clamp: 4; }
			}
			.box1::after{content: "";display: block;position: absolute; left:0;top:0;border-top: 20px solid #5ea5e2;border-right: 20px solid transparent;z-index: 3;}
			.box2{width: 276px;height:370px;float: left;margin-bottom: 30px;margin-right: 30px;text-align: left;position: relative;
				.avatar{height:280px;background-repeat: no-repeat;background-position: center center;background-size: cover;}
				.username{margin-top: 10px;font-size: 20px;text-align: left;}
				.job{margin-top: 5px;font-size: 14px;color:#929292;white-space: pre-line;-webkit-line-clamp: 4; }
			}
		}
		.item:nth-child(4n){
			.box1{margin-right: 0;}
			.box2{margin-right: 0;}
		}
		.item:hover{
			.hover{height:auto;box-shadow: 0 0 20px 10px rgba(1,118,207,.1);}
		}
		.item.end:hover{
			.hover{bottom:0;top:auto;}
		}
		.loading{margin: 50px auto;}
	}
	.tips { font-size:14px; padding-bottom: 50px;text-align: left;color:#999;width: 1200px;margin: 0 auto;
		i{color:red;}
	}
}
</style>

